"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultHost = exports.ServerEnvironment = exports.ServerType = void 0;
var ServerType;
(function (ServerType) {
    ServerType["SUMO"] = "SUMO";
    ServerType["SALESFORCE"] = "SALESFORCE";
})(ServerType = exports.ServerType || (exports.ServerType = {}));
var ServerEnvironment;
(function (ServerEnvironment) {
    ServerEnvironment["PRODUCTION"] = "PRODUCTION";
    ServerEnvironment["SANDBOX"] = "SANDBOX";
})(ServerEnvironment = exports.ServerEnvironment || (exports.ServerEnvironment = {}));
var DefaultHost;
(function (DefaultHost) {
    DefaultHost["ME"] = "ME";
    DefaultHost["NONE"] = "NONE";
})(DefaultHost = exports.DefaultHost || (exports.DefaultHost = {}));
